<template>
  <ViewTopNav :heading="this.viewType" :subheading="this.assetType" />

  <div class="position-absolute p-content z-1">
    <div class="col-12 p-0 z-1 h-100">
      <div class="row g-0 h-100">
        <!-- Carousel for Renders -->
        <div class="col-12">
          <div
            id="rendersCarousel"
            class="carousel slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-indicators">
              <button
                v-for="(asset, index) in assetTypes"
                :key="asset.guid"
                type="button"
                :data-bs-target="'#rendersCarousel'"
                :data-bs-slide-to="index"
                :class="{ active: index === 0 }"
                aria-current="index === 0 ? 'true' : 'false'"
                :aria-label="'Slide ' + (index + 1)"
              ></button>
            </div>
            <div class="carousel-inner">
              <div
                v-for="(asset, index) in assetTypes"
                :key="asset.guid"
                :class="['carousel-item', { active: index === 0 }]"
              >
                <img
                  :src="
                    theme.cdnUrl +
                    '/assets/' +
                    this.assetType +
                    '/' +
                    this.viewType +
                    '/' +
                    asset.LinkName +
                    '?width=700'
                  "
                  class="d-block w-100 img-fluid"
                  style="height: 90vh; object-fit: contain"
                  :alt="asset.title"
                />
                <div class="carousel-caption d-none d-md-block">
                  <h5>{{ asset.title }}</h5>
                </div>
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#rendersCarousel"
              data-bs-slide="prev"
            >
              <span
                class="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button
              class="carousel-control-next"
              type="button"
              data-bs-target="#rendersCarousel"
              data-bs-slide="next"
            >
              <span
                class="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ViewBotNav />
</template>

<script>
import ViewTopNav from '@/components/ViewTopNav.vue'
import ViewBotNav from '@/components/ViewBotNav.vue'
import OffCanvas from '@/components/OffCanvas.vue'
import global from '../global'
import BunnyNetService from '@/services/BunnyNetService.js'
import { unslugify } from 'unslugify'

export default {
  name: 'AssetView',
  props: ['assetType', 'viewType', 'lid', 'collectionId'],
  components: {
    ViewTopNav,
    ViewBotNav,
    OffCanvas,
  },
  data() {
    return {
      assetTypes: null,
      assetOrder: null,
      folderStructure: encodeURIComponent(
        this.theme.devFolder +
          '/assets/' +
          this.assetType +
          '/' +
          this.viewType +
          '/'
      ),
      videoStatus: false,
      assetNames: null,
      assetUrls: null,
    }
  },
  created() {
    if (this.viewType === 'renders') {
      this.assetOrder = this.theme.retreatAsset.floorplans
      this.assetNames = this.theme.retreatAsset.floorplansName
      this.assetUrls = this.theme.retreatAsset.floorplansUrl
    }

    BunnyNetService.getRenders(this.folderStructure, this.assetType).then(
      (response) => {
        let j = 0
        // Remap array
        const menuItems = response.data.map((item) => {
          return {
            Guid: item.Guid,
            ObjectName: unslugify(item.ObjectName),
            LinkName: item.ObjectName,
            Path: item.Path,
            IsDirectory: item.IsDirectory,
            StorageZoneName: item.StorageZoneName,
            title: this.assetNames[j],
            url: this.assetUrls[j],
            id: j++,
          }
        })

        this.assetTypes = menuItems
      }
    )
  },
  methods: {
    reorder: function (data_array, real_order) {
      var i,
        d = {},
        result = []
      for (i = 0; i < data_array.length; ++i) {
        d[data_array[i].id] = data_array[i]
      }

      for (i = 0; i < real_order.length; ++i) {
        result.push(d[real_order[i]])
      }

      return result
    },
  },
  setup() {
    const { theme } = global

    return {
      theme,
    }
  },
}
</script>
